import axios from "@/plugins/axios";

export default {
  signin(credentials) {
    return axios.httpApi.post('user/_signin', credentials)
  },

  update_user_bitzen(credentials) {
    return axios.httpAuth.post('/create-update-user', credentials)
  },
}